module.exports = __webpack_public_path__ + "img/slider-bg-mobile.b93374f1.svg";